<template>
  <dispute-list
    @downloadReport="downloadReport($event)"
    @downloadEvidence="downloadEvidenceClick($event)"
    @submitEvidence="submitEvidenceClick($event)"
    @loadData="loadData($event)"
    :disputes="disputes"
    :evidenceLoading="evidenceLoading"
    :disputesLoading="disputesLoading"
    :selectedLanguage="selectedLanguage"
    :reportGenerating="reportGenerating"
    :totalDisputes="totalCount"
  ></dispute-list>
</template>

<script>
import DisputeList from '../../components/DisputeList.vue';
import dayjs from '../../plugins/dayjs';
import { listDisputes } from '../../mixins/disputes.mixins';
import { languageMethods, languageComputed } from '../../mixins/language.mixins';
import { csvReport } from '../../mixins/csvReport.mixins';
import { evidence } from '../../mixins/evidence.mixins';
import { download } from '../../mixins/download.mixins';

export default {
  name: 'list-dispute-view',
  components: { DisputeList },
  mixins: [
    csvReport,
    download,
    evidence,
    listDisputes,
    languageMethods,
    languageComputed,
  ],
  computed: {
    totalCount() {
      return this.disputesListInfo.totalCount;
    },
  },
  methods: {
    async loadData({
      sort, page, maxPerPage, startDate, endDate, dateType, dynamicSearch,
    }) {
      this.disputesSearchObject = {
        page,
        maxPerPage,
        sort,
        startDate,
        endDate,
        dateType,
        dynamicSearch,
      };
      await this.listDisputes();
    },

    async submitEvidenceClick({ disputeId, comment }) {
      await this.submitEvidence({ disputeId, comment });
      await this.listDisputes();
    },

    async downloadEvidenceClick({ disputeId, evidenceFilename }) {
      const result = await this.downloadEvidence(disputeId);

      if (!result.errorCode) {
        this.download({ data: this.evidenceData, filename: evidenceFilename, type: 'application/pdf' });
      }
    },

    async downloadReport({ startDate, endDate, dateType, sort }) {
      const filename = `${this.$t(
        'pages.dispute.list.filenamePrefix',
      )}-${dayjs().format('YYYY-MM-DD_HHmmss')}.csv`;
      this.reportDisputeGenerationObject = {
        filename,
        startDate,
        endDate,
        dateType,
        sort,
      };

      const result = await this.generateDisputeReport();

      if (!result.errorCode) {
        this.download({ data: this.reportData, filename });
      }
    },
  },
};
</script>
